export default __webpack_public_path__ + "static/media/undraw_forgot_password_dark.52013adb.svg";